<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_11"></a>DRAMATIS PERSONAE</h2>
<p class="noindent2">THE IMPERIALS</p>
<p class="indentx"><strong>Tezozómoc,</strong> a Méxica prince of low repute. The youngest son of the reigning Méxica Emperor Ahuitzotl</p>
<p class="indentx">Master Sergeant Lorne <strong>Colmuir,</strong> a Skawtish Eagle Knight, the prince’s bodyguard</p>
<p class="indentx">Sergeant Leslie <strong>Dawd,</strong> a Skawtish Eagle Knight, and the prince’s other bodyguard</p>
<p class="indentx"><strong>Yacatolli,</strong> <em>Tlacateccatl</em> (Colonel) of the 416th Arrow Knight regiment (motorized)—the “Tarascan Rifles”</p>
<p class="noindent2">THE CREW OF THE IMN HENRY R. CORNUELLE</p>
<p class="indentx"><em>Chu-sa</em> (Commander) <strong>Mitsuharu Hadeishi,</strong> captain</p>
<p class="indentx"><em>Sho-sa</em> (Lieutenant Commander) <strong>Susan Koshō,</strong> executive officer</p>
<p class="indentx"><em>Thai-i</em> (Senior Lieutenant, weapons officer) Patrick <strong>Hayes</strong></p>
<p class="indentx"><em>Thai-i</em> (Senior Lieutenant, engineering) <strong>Isoroku</strong> Oushi</p>
<p class="indentx"><em>Sho-i</em> (Midshipman, communications) Daniel <strong>Smith</strong></p>
<p class="indentx"><em>Thai-i</em> (Senior Lieutenant, Marine detachment) <strong>Huémac</strong></p>
<p class="indentx"><em>Gunso</em> (Sergeant) “Hork” <strong>Fitzsimmons,</strong> Imperial Marines</p>
<p class="indentx"><em>Heicho</em> (Corporal) <strong>Felix,</strong> Imperial Marines</p>
<p class="indentx">Captain’s Steward Kusaru <strong>Yejin</strong></p>
<p class="indentx"><strong>Helsdon,</strong> chief machinist’s mate</p>
<p class="noindent2">IMPERIAL CITIZENS ON JAGAN</p>
<p class="indentx"><strong>Itzpalicue</strong> (Skirt-of-Knives), agent of the Mirror Which Reveals The Truth</p>
<p class="indentx">Mrs. Greta Hauksbee <strong>Petrel,</strong> wife of the Imperial Resident on Jagan</p>
<p class="indentx"><strong>Soumake,</strong> Imperial attaché in charge of Antiquities, Jagan</p>
<p class="indentx">Johann <strong>Gemmilsky,</strong> Polish expatriate, riding lizard trader</p>
<p class="noindent2">THE HONORABLE CHARTERED COMPANY</p>
<p class="indentx">Doctor <strong>Gretchen</strong> Anderssen, xenoarchaeologist, mother of three</p>
<p class="indentx">David <strong>Parker,</strong> Company Pilot, assigned to Anderssen’s analysis team</p>
<p class="indentx"><strong>Magdalena,</strong> Hesht communications and systems expert, also assigned to</p>
<p class="indentx">Anderssen’s analysis team</p>
<p class="noindent2">THE JEHANAN</p>
<p class="indentx"><strong>Bhrigu,</strong> <em>kujen</em> of Parus, lord of the Seven Rivers</p>
<p class="indentx"><strong>Bhāzuradeha,</strong> a poetess, client of the <em>kujen</em> Bhrigu</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter005.vue?d06ed192